import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clapperboard, Search, Upload } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { VideoCard } from "@/components/ott/VideoCard";

const Row = ({ title, items, testid, progress }) => items?.length ? (
  <section className="mb-6" data-testid={testid}>
    <div className="text-[13px] uppercase tracking-widest font-black text-stone-700 mb-2">{title}</div>
    <div className="grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))" }}>
      {items.map((v) => <VideoCard key={v.video_id} v={v} progress={progress ? v.position_s : 0} />)}
    </div>
  </section>
) : null;

export default function Ott() {
  const { user } = useAuth();
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState("");
  const [q, setQ] = useState("");
  const [term, setTerm] = useState("");
  const [videos, setVideos] = useState(null);
  const [lib, setLib] = useState(null);
  useEffect(() => { api.get("/ott/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);
  useEffect(() => { if (user) api.get("/ott/me/library").then((r) => setLib(r.data)).catch(() => {}); }, [user]);
  useEffect(() => {
    setVideos(null);
    api.get("/ott/videos", { params: { category: cat, q: term } }).then((r) => setVideos(r.data)).catch(() => setVideos([]));
  }, [cat, term]);
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-6" data-testid="ott-page">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-stone-500 font-bold flex items-center gap-2"><Clapperboard size={12} className="text-red-600" /> Find2Near OTT</div>
          <h1 className="heading text-3xl md:text-4xl font-black text-stone-900">Local creators. <span className="text-red-600">Real stories.</span></h1>
        </div>
        <Link to="/ott/upload" className="inline-flex items-center gap-2 rounded-full bg-red-600 text-white font-bold px-4 py-2 text-sm" data-testid="ott-upload-link"><Upload size={14} /> Publish a video</Link>
      </div>
      <form onSubmit={(e) => { e.preventDefault(); setTerm(q.trim()); }} className="flex items-center gap-2 bg-white border border-stone-200 rounded-full px-3 mb-3">
        <Search size={14} className="text-stone-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search videos" className="w-full py-2 outline-none text-sm bg-transparent" data-testid="ott-search" />
      </form>
      <div className="flex flex-wrap gap-1.5 mb-5">
        {["", ...cats].map((c) => (
          <button key={c || "all"} onClick={() => setCat(c)} data-testid={`ott-cat-${c || "all"}`}
                  className={`text-[11px] font-black rounded-full px-3 py-1.5 border capitalize ${cat === c ? "bg-stone-900 text-white border-stone-900" : "bg-white text-stone-700 border-stone-200"}`}>{c ? c.replace("-", " ") : "All"}</button>
        ))}
      </div>
      {!cat && !term && <><Row title="Continue watching" items={lib?.continue} testid="ott-continue" progress /><Row title="My watchlist" items={lib?.watchlist} testid="ott-watchlist" /></>}
      {videos === null ? <div className="text-stone-400 text-sm">Loading…</div>
        : videos.length ? <Row title={term ? `Results for “${term}”` : "Latest"} items={videos} testid="ott-latest" />
        : <div className="rounded-2xl border border-dashed border-stone-300 bg-white p-6 text-sm text-stone-600" data-testid="ott-empty">No published videos {term ? `match “${term}”` : "here yet"}. Every video is reviewed or comes from a trusted creator.</div>}
    </div>
  );
}
